import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "eye2",
  "use": "eye2-usage",
  "viewBox": "0 0 22 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 16\" id=\"eye2\">\n  <path d=\"M11 .5C6 .5 1.73 3.61 0 8a11.83 11.83 0 0 0 22 0C20.27 3.61 16 .5 11 .5zM11 13a5 5 0 1 1 0-10 5 5 0 0 1 0 10zm0-8a3 3 0 1 0 0 6 3 3 0 0 0 0-6z\" fill=\"#677078\" fill-rule=\"nonzero\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol